import React from "react";
import { SelectedIcon, UnselectedIcon } from "@bluecrew/blueprint-web/src/assets";
import { ListItemCheckboxProps } from "./types";

export const ListItemCheckbox = ({ selected }: ListItemCheckboxProps) =>
  selected ? <SelectedIcon /> : <UnselectedIcon />;
